// extracted by mini-css-extract-plugin
export default {"container":"Info_container__mx+Is","download":"Info_download__mAPuV"};